import React from "react";
import DisclosureCore from "../../../utils/disclosure/DisclosureCore";
import H3 from "../../../elements/titles/H3";
import Paragraph from "../../../elements/p/Paragraph";
import Container from "../../../utils/Container";

const TypeOfUser = () => {
  return (
    <Container classe="mt-3">
      <DisclosureCore title="Les types d'utilisateurs de la boutique">
        <Paragraph>
          L'application web se comportera différemment selon le type
          d'utilisateur qui naviguera sur le site. Il existe 03 principaux types
          d'utilisateurs :
        </Paragraph>
        <ul className="mt-4 flex list-inside flex-col space-y-5">
          <li>
            <H3>1. Les utilisateurs qui n'ont pas créé de compte :</H3>
            <Paragraph>
              Ce sont les utilisateurs avec les droits les plus restreints de la
              plateforme. Ils pourront juste consulter les produits, effectuer.
              des recherches ciblés. En cliquant sur les 3 petits points (...)
              en haut et à gauche de chaque produit, ils pourront le partager
              via les réseaux sociaux.
            </Paragraph>
          </li>
          <li>
            <H3>2. Les utilisateurs qui ont créé un compte utilisateur :</H3>
            <Paragraph>
              En plus de tout ce qu'un utilisateur sans compte peut faire, les
              utilisateurs ayant un compte peuvent enregistrer des produits en
              cliquant sur les 3 petits points (...) du produit concerné.
            </Paragraph>
          </li>
          <li>
            <H3>3. L'administrateur</H3>
            <Paragraph>
              C'est l'utilisateur ayant le plus de privilèges dans
              l'application, il est capable d'ajouter, modifier, supprimer des
              produits, des catégories leurs catégories. Il pourra aussi
              visualiser la liste des utilisateurs inscrits qu'il n'a pas encore
              prospectés. L'ajout des produits et catégories est réalisé depuis
              l'interface d'administration. Tandis que la modification et
              suppression de ceux-ci sont effectues en cliquant sur les 3 petits
              points (...) du produit ou catégorie conservé.
            </Paragraph>
          </li>
        </ul>
      </DisclosureCore>
    </Container>
  );
};

export default TypeOfUser;
